import React from 'react';
import styles from './SafetyTips.module.css';
import SafetyTipsText from '../Components/SafetyTips';
import Footer from '../../Desktop/Components/Footer';

const SafetyTips = ({onNavigate}) => {
  return (
    <section className={styles.safetyTips}>
      <div className={styles.body}>
      <h2 className={styles.titleText}>Be bold, stay safe</h2>
      </div>
     
      <div className={styles.text}>
      <SafetyTipsText/>
      </div>
      <Footer onNavigate={onNavigate}/>
    </section>
    
  );
};

export default SafetyTips;
